<template>
  <VTask
    :task="task"
    v-bind="$attrs"
    :enabled="task?.status !== 'Cancelled' && !task.item_deleted_at"
    @click="onClickRedirect"
  >
    <template #open>
      <VButton
        class="btn secondary !text-magenta-0 btn-sm !border-magenta-1 hover:!bg-task-btn-bg round"
        :class="btnSize"
        @click="onClickRedirect"
      >
        {{ $t('view') }}
      </VButton>
    </template>
  </VTask>
</template>

<script>
import { useRouter } from 'vue-router';
// Components
import VTask from '@/components/templates/tasks/VTask';
import VButton from '@/components/VButton';
// Constants
import ALL_OPTIONS from '@/constants/options';

export default {
  components: {
    VTask,
    VButton
  },
  props: {
    task: {
      type: Object,
      default: () => ({})
    },
    btnSize: {
      type: String,
      default: ''
    }
  },
  emits: ['update', 'click'],
  setup (props, context) {
    const router = useRouter();

    // Methods
    const onClickRedirect = () => {
      let name = 'content-jobs-id-edit';
      if ([ALL_OPTIONS.PUBLISHED.value, ALL_OPTIONS.DEPRECATED.value].includes(props.task?.job_status) && props.task?.status === ALL_OPTIONS.COMPLETED.value) {
        name = 'content-jobs-id-description';
      }

      router.push({
        name,
        params: {
          id: props.task?.taskable_id
        }
      });

      context.emit('click');
    };

    return {
      ALL_OPTIONS,
      onClickRedirect
    };
  }
};
</script>
